module.exports = __webpack_public_path__ + "static/media/tacometro-bajo-p.07f1ade2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-bajo-p.svg
// module id = 150
// module chunks = 0